// Redeploy 2026-08-07 (a peticion: redeploy junto con el primer apply de infra)
import i18n from './i18n'
import './styles/forms.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { RouterProvider } from 'react-router-dom'
import { APIProvider } from '@vis.gl/react-google-maps'
import { GOOGLE_MAPS_API_KEY } from './lib/googleMaps'
import { system } from './theme'
import { router } from './routes'
import { ThemeProvider } from './hooks/useTheme'
import { AuthProvider } from './contexts/AuthContext'
import { PermissionProvider } from './auth/PermissionContext'
import { Toaster, I18nProvider } from '@minetrace/ui'
import SessionRefreshOverlay from './components/SessionRefreshOverlay'

const translate = (key: string, values?: Record<string, unknown>) =>
  i18n.t(key, values as Record<string, string>) as string

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider translate={translate}>
      <ChakraProvider value={system}>
        <ThemeProvider>
          <AuthProvider>
            <PermissionProvider>
              <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
                <RouterProvider router={router} />
              </APIProvider>
            </PermissionProvider>
          </AuthProvider>
        </ThemeProvider>
        <Toaster />
        <SessionRefreshOverlay />
      </ChakraProvider>
    </I18nProvider>
  </StrictMode>,
)
